import { Directive, HostListener, Renderer2, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';

const relativeUrlPattern = /^\/[^\\/]+/;

@Directive({
    selector: '[ridangoTranslatedLink]'
})
export class TranslatedLinkHandlerDirective {
    constructor(
        private viewRef: ViewContainerRef,
        private renderer: Renderer2,
        private router: Router
    ) {}

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;

        if (event.target instanceof HTMLAnchorElement === false) {
            return;
        }

        const hrefValue = target.getAttribute('href');
        const targetValue = target.getAttribute('target');

        if (hrefValue === '#') {
            event.stopPropagation();
            event.preventDefault();
            return;
        }

        if (!relativeUrlPattern.test(hrefValue)) {
            return;
        }

        if (event.button !== 0 || event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) {
            return;
        }

        if (typeof targetValue === 'string' && targetValue !== '_self') {
            return;
        }

        event.preventDefault();
        this.router.navigate([hrefValue]);
    }
}
